'use memo';

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { useSidebarPortalStore } from '@/components/SidebarPortal';
import { useDesktopOrMobileMediaQuery } from '@/hooks/useMediaQuery';
import { useSequenceSidebarData } from '@/routes/_chat/chat/$sessionId/-query';
import { IndividualSidebar } from '../-components/IndividualSidebar';
import { loadPortalData } from './-api';
import { ApprovalTrayCard } from './-components/ApprovalTrayCard';
import { ClockingCard } from './-components/ClockingCard';
import { GreetingHero } from './-components/GreetingHero';
import { MyRequestsCard } from './-components/MyRequestsCard';
import { TaskListCard } from './-components/TaskListCard';
import { ApprovalDrawer } from './approvals/-components/ApprovalDrawer';
const SearchSchema = z.object({
  selectedApprovalId: z.string().optional().catch(undefined)
});
export const Route = createFileRoute('/_individual/individual/portal/')({
  validateSearch: zodValidator(SearchSchema),
  loader: () => loadPortalData(),
  component: PortalPage
});
function PortalPage() {
  const {
    attendance,
    tasks,
    approvals,
    requests
  } = Route.useLoaderData();
  const search = Route.useSearch();
  const navigate = useNavigate({
    from: Route.fullPath
  });
  const sidebarData = useSequenceSidebarData();
  const sidebarOpen = useSidebarPortalStore(state => state.isOpen);
  const toggleSidebar = useSidebarPortalStore(state => state.toggleOpen);
  const {
    isDesktop
  } = useDesktopOrMobileMediaQuery();
  const openApprovalDrawer = (id: string) => navigate({
    search: s => ({
      ...s,
      selectedApprovalId: id
    })
  });
  const closeApprovalDrawer = () => navigate({
    search: s => ({
      ...s,
      selectedApprovalId: undefined
    })
  });
  return <div className="flex h-full min-h-0 w-full overflow-hidden">
      {isDesktop && <IndividualSidebar mode="portal" open={sidebarOpen} onToggle={toggleSidebar} recentSessions={sidebarData.data?.recentSessions ?? []} upcomingInteractions={sidebarData.data?.upcomingInteractions ?? []} />}
      <main className="min-w-0 flex-1 overflow-auto bg-neutral-bottom-fill">
        <div className="min-h-full bg-blue-50/30">
          <div className="mx-auto max-w-[1280px] px-4 py-6 md:px-[100px] md:py-10">
            <div className="mx-auto flex w-full max-w-[800px] flex-col gap-6">
              <GreetingHero />
              <ClockingCard attendance={attendance} />
              <TaskListCard tasks={tasks} />
              <ApprovalTrayCard approvals={approvals} onRowClick={openApprovalDrawer} />
              <MyRequestsCard requests={requests} />
            </div>
          </div>
        </div>
      </main>
      <ApprovalDrawer approvalId={search.selectedApprovalId} open={Boolean(search.selectedApprovalId)} onClose={closeApprovalDrawer} />
    </div>;
}